import React, { useState } from 'react';
import { ResourceContext } from '../Resource';
import { useDataProvider } from './useDataProvider';
import { useResource } from './useResource';
import { pickDataProvider } from '../helper/pickDataProvider';
import { handleErrorResponse } from '../helper/handleErrorResponse';

export const useUpdate = (props) => {
  const { resources } = React.useContext(ResourceContext);
  const dataProvider = useDataProvider();
  const [result, setResult] = useState({
    loading: false,
    error: null,
    data: [],
  });
  const { id, resource: resourceName, dataProvider: dataProviderName, meta } = props;
  const resource = useResource({ resourceName });
  const pickedDataProvider = pickDataProvider(resourceName, dataProviderName, resources);
  const pickedMeta = {
    ...resource.meta,
    ...meta,
  };

  const { update } = dataProvider(pickedDataProvider);

  /**
   * To customer method for route update
   * @example options.method ="PUT/PATCH"
   * @param {*} variables
   * @param {*} options
   */
  const handleUpdate = async (variables, options = {}) => {
    try {
      setResult({
        ...result,
        loading: true,
      });

      const data = await update({
        id,
        resource: resource.edit || resourceName,
        variables,
        meta: pickedMeta,
        ...options,
      });
      if (data.error) {
        throw handleErrorResponse(data);
      }
      setResult({
        ...result,
        error: null,
        data,
        loading: false,
      });
      return data;
    } catch (error) {
      console.trace('Use Update Error', error);
      setResult({
        ...result,
        loading: false,
        error,
      });
      throw error;
    }
  };
  return {
    ...result,
    meta: pickedMeta,
    mutate: handleUpdate,
  };
};
